import React, { useState } from "react";
import UploadComponent from "../global/UploadComponent";
import { ChatBox } from "../../components/chat";

const MainDiagnosis = ({ viewDiagnosis, setViewDiagnosis }) => {
  const [toggleAction, setToggleAction] = useState("photo");

  return (
    <div
      className={
        viewDiagnosis === true
          ? "main-diagnosis show-diagnosis"
          : "main-diagnosis hide-diagnosis"
      }
    >
      <div className="over-lay" onClick={() => setViewDiagnosis(false)}></div>
      <div className="content-diagnosis">
        <h2>diagnosis</h2>
        <div className="buttons-diagnosis">
          <button
            onClick={() => setToggleAction("photo")}
            className={toggleAction === "photo" && "active"}
          >
            photo
          </button>
          <button
            onClick={() => setToggleAction("chat")}
            className={toggleAction === "chat" && "active"}
          >
            Chat
          </button>
        </div>
        {toggleAction === "photo" && (
          <form className="photo-upload">
            <h3>skin image upload </h3>
            <UploadComponent />
            <div className="buttons-action mb--large">
              <button onClick={() => setViewDiagnosis(false)}> Cancel</button>

              <button onClick={() => {}}> send</button>
            </div>
          </form>
        )}
        {toggleAction === "chat" && <ChatBox />}
      </div>
    </div>
  );
};

export default MainDiagnosis;
